export default "__VITE_ASSET__21429907__"